import React from "react";

export const ArticleShimmer = () => {
  return (
    <div className="animate-pulse">
      <div className="flex flex-col gap-4">
        {/* Image placeholder */}
        <div className="h-[200px] w-full rounded-[20px] bg-gray-200"></div>

        {/* Title placeholder */}
        <div className="space-y-3">
          <div className="h-4 w-3/4 rounded bg-gray-200"></div>
          <div className="h-4 w-1/2 rounded bg-gray-200"></div>
        </div>

        {/* Meta info placeholder */}
        <div className="flex items-center gap-2">
          <div className="h-3 w-20 rounded bg-gray-200"></div>
          <div className="h-2 w-2 rounded-full bg-gray-200"></div>
          <div className="h-3 w-24 rounded bg-gray-200"></div>
        </div>
      </div>
    </div>
  );
};

export const ArticlesGridShimmer = () => {
  return (
    <div className="grid grid-cols-1 gap-[32px] lg:grid-cols-2 lg:gap-x-[64px] lg:gap-y-[80px]">
      {[...Array(6)].map((_, index) => (
        <ArticleShimmer key={index} />
      ))}
    </div>
  );
};
